<template>
    <div class="card p-3 rounded-more d-flex flex-column gap user-select-none">
        <div class="d-flex flex-row gap-0.5">
            <div class="rect"></div>
            <h4 class="text-md text-bold">Investors Invited</h4>
        </div>
        <div class="d-flex flex-row gap justify-content-end align-items-center">
            <div class="text-xl text-bold">{{total}}</div>
            <router-link to="/introduction-broker/investor" class="link">
                <i class="fas fa-chevron-right fa-2x"></i>
            </router-link>
        </div>
    </div>
</template>

<script>
export default {
    name : "InvestorsInvitedCard",
    props : {
        total : {
            type : Number,
            default : 0
        }
    }
}
</script>